import { render, staticRenderFns } from "./LegalArea.vue?vue&type=template&id=1e1a9415&"
import script from "./LegalArea.vue?vue&type=script&lang=ts&"
export * from "./LegalArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports